import React, { useId } from "react";
import { useMapSettings } from "../../context/MapSettingsContext";
import "./AjustesPage.css";

const OPTIONS = [
  { key: "grises", label: "Escala de grises" },
  { key: "topografico", label: "Topográfico" },
  { key: "calles", label: "Calles" },
  { key: "satelite", label: "Satélite (con nomenclatura)" },
];

export default function AjustesPage() {
  const { baseLayer, setBaseLayer } = useMapSettings();
  const groupId = useId();

  return (
    <div className="static-page">
      <div className="static-page__inner">
        <h1 className="static-page__title">Ajustes</h1>
        <p className="static-page__subtitle">Preferencias del visor</p>

        <div className="static-card">
          <div className="static-card__accent" aria-hidden />
          <h2 className="ajustes-section-title">Capas del mapa</h2>

          <div
            className="ajustes-layer-list"
            role="radiogroup"
            aria-label="Capas del mapa"
          >
            {OPTIONS.map((opt) => {
              const id = `${groupId}-${opt.key}`;
              const checked = baseLayer === opt.key;
              return (
                <label key={opt.key} className="ajustes-layer-row" htmlFor={id}>
                  <span className="ajustes-layer-text">{opt.label}</span>
                  <span className="ajustes-layer-control">
                    <input
                      id={id}
                      type="radio"
                      name={groupId}
                      value={opt.key}
                      checked={checked}
                      onChange={() => setBaseLayer(opt.key)}
                    />
                    <span className="ajustes-switch" aria-hidden />
                  </span>
                </label>
              );
            })}
          </div>

          <div className="ajustes-hint">
            Al cambiar la capa, el mapa se actualiza automáticamente.
          </div>
        </div>
      </div>
    </div>
  );
}
